import NewCustomer from "../../../../components/@users/customers/NewCustomer"

import { routeTypes } from "../../../../../../hooks/useSystemRoutes"

export default function CustomerNewPage() {

    return (
        <NewCustomer 
            routeType={routeTypes.admin}
        />
    )
}       